import { render, staticRenderFns } from "./onboardemployee.vue?vue&type=template&id=69cb73fc&scoped=true"
import script from "./onboardemployee.vue?vue&type=script&lang=js"
export * from "./onboardemployee.vue?vue&type=script&lang=js"
import style0 from "./onboardemployee.vue?vue&type=style&index=0&id=69cb73fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69cb73fc",
  null
  
)

export default component.exports